<template>
    <div class="FotavOutputTable">
        <div class="flex-column">
            <div style="width: 100%; height: calc(100vh - 83px)">
                <DxDataGrid ref="FotavOutputTableList"
                            :data-source="dataSource"
                            :column-auto-width="true"
                            :row-alternation-enabled="true"
                            :allow-column-resizing="true"
                            :show-row-lines="true"
                            :show-borders="true"
                            @initialized="onInitialized"
                            @init-new-row="onInitNewRow"
                            @row-prepared="onRowPrepared"
                            @toolbar-preparing="onToolbarPreparing"
                            height="100%">

                    <DxEditing :allow-deleting="true"
                               :use-icons="true" />

                    <DxPaging :page-size="500" />
                    <DxPager :visible="false" />
                    <DxFilterRow :visible="true"
                                 apply-filter="auto" />

                    <DxScrolling show-scrollbar="always"
                                 column-rendering-mode="standard"
                                 row-rendering-mode="standard"
                                 :mode="'virtual'"
                                 :preload-enabled="false" />

                    <DxColumn data-field="id"
                              caption="#"
                              :allowEditing="false"
                              width="50"
                              alignment="center"
                              cell-template="idColumnTemplate" />
                    <DxColumn data-field="filename"
                              caption="Fájlnév"
                              header-cell-template="title-header" />
                    <DxColumn data-field="month"
                              caption="Hónap"
                              :customize-text="monthFormat"
                              header-cell-template="title-header"
                              alignment="left"
                              data-type="datetime" />
                    <DxColumn data-field="createdBy"
                              caption="Létrehozó"
                              header-cell-template="title-header" />
                    <DxColumn data-field="createdDate"
                              caption="Létrehozás dátuma"
                              :customize-text="dateFormat"
                              header-cell-template="title-header"
                              alignment="right"
                              data-type="datetime" />
                    <DxColumn caption="Akciók"
                              sortOrder="0"
                              :allow-resizing="false"
                              :allow-reordering="false"
                              :min-width="60"
                              :width="100"
                              type="buttons">
                        <DxButton name="download"
                                  hint="Letöltés"
                                  icon="download"
                                  :onClick="downloadBtnClick" />
                        <DxButton name="print"
                                  hint="Nyomtatás"
                                  icon="print"
                                  :onClick="printBtnClick" />
                        <DxButton name="delete"
                                  hint="Törlés"
                                  icon="trash" />
                    </DxColumn>

                    <template #title-header="{ data }">
                        <div class="d-flex">
                            <div class="flex-1 text-left">{{ data.column.caption }}</div>
                        </div>
                    </template>

                    <template #idColumnTemplate="{ data: cellInfo }">
                        {{ rowId(cellInfo) }}
                    </template>

                    <template #validColumnHeader="{ data }">
                        <i class="dx-icon-warning warning-icon-header"></i>
                    </template>

                    <template #generateStatement="{ data }">
                        <div>
                            <DxBtn name="generate"
                                   hint="Szétosztási adatok kiszámítása"
                                   text="Szétosztási adatok kiszámítása"
                                   icon="inserttable"
                                   @click="openPopup" />
                        </div>
                    </template>

                    <template #generateReportBtn="{ data }">
                        <div>
                            <DxBtn name="generateReportBtn"
                                   hint="Riportgenerálás"
                                   text="Riportgenerálás"
                                   icon="doc"
                                   @click="openPopupGR" />
                        </div>
                    </template>

                </DxDataGrid>
            </div>
        </div>

        <DxPopup width="400"
                 :height="300"
                 :show-title="true"
                 title="Főtáv szétosztási adatok kiszámítása"
                 :drag-enabled="false"
                 :close-on-outside-click="true"
                 :show-close-buttton="true"
                 :onInitialized="onPopupInit"
                 :onShowing="onShowing">

            <DxPopupToolbarItem widget="dxButton"
                                toolbar="bottom"
                                location="after"
                                :options="generateBtn" />

            <DxPopupToolbarItem widget="dxButton"
                                toolbar="bottom"
                                location="after"
                                :options="closeBtn" />

            <template #content="{ data }">
                <div style="width:100%">
                    <div class="form-input">
                        <label>Főtáv szétosztási adatok sablon</label>
                        <DxSelectBox v-model="selectedTemplate"
                                     :items="templates"
                                     display-expr="name"
                                     value-expr="id" />
                    </div>
                    <div class="form-input">
                        <label>Elszámolási időszak (hónap)</label>
                        <DxDateBox v-model:value="selectedMonth"
                                   type="date"
                                   display-format="monthAndYear">

                            <DxCalendarOptions min-zoom-level="century"
                                               max-zoom-level="year" />
                        </DxDateBox>
                    </div>
                </div>
            </template>
        </DxPopup>

        <DxPopup width="700"
                 :height="600"
                 :show-title="true"
                 title="Riportgenerálás"
                 :drag-enabled="false"
                 :close-on-outside-click="true"
                 :show-close-buttton="true"
                 :onInitialized="onPopupInitGR">

            <DxPopupToolbarItem widget="dxButton"
                                toolbar="bottom"
                                location="after"
                                :options="generateBtnGR" />

            <DxPopupToolbarItem widget="dxButton"
                                toolbar="bottom"
                                location="after"
                                :options="closeBtnGR" />

            <template #content="{ data }">
                <div>
                    <DxForm id="formGR"
                            :col-count="1"
                            :form-data="generateReportFormData"
                            required-mark="*"
                            label-location="top">
                        <DxGroupItem caption="Időszak és díjfizetők kiválasztása" :col-count="2">
                            <DxSimpleItem data-field="from"
                                          :is-required="true"
                                          editor-type="dxDateBox"
                                          :editor-options="calendarOptionsFrom">
                                <DxLabel text="Időszak kezdete" :show-colon="false" />
                            </DxSimpleItem>
                            <DxSimpleItem data-field="to"
                                          :is-required="true"
                                          editor-type="dxDateBox"
                                          :editor-options="calendarOptionsTo">
                                <DxLabel text="Időszak vége" :show-colon="false" />
                            </DxSimpleItem>
                        </DxGroupItem>
                       
                    </DxForm>
                        
                    <DxDataGrid ref="CustomerList"
                                :data-source="customerSource"
                                :column-auto-width="true"
                                :row-alternation-enabled="true"
                                :allow-column-resizing="true"
                                :show-row-lines="true"
                                :show-borders="true"
                                height="308"
                                :selected-row-keys="selectedRowKeys"
                                @selection-changed="onSelectionChanged"
                                @initialized="onInitializedGR">

                        <DxEditing :allow-deleting="false" />
                        <DxPager :visible="false" />
                        <DxFilterRow :visible="true"
                                     apply-filter="auto" />
                        <DxScrolling show-scrollbar="always"
                                     column-rendering-mode="standard"
                                     row-rendering-mode="standard"
                                     :mode="'virtual'"
                                     :preload-enabled="true" />
                        <DxSelection select-all-mode="allPages"
                                     show-check-boxes-mode="onClick"
                                     mode="multiple" />

                        <DxColumn caption="#"
                                  :allowEditing="false"
                                  width="50"
                                  alignment="center"
                                  cell-template="idColumnTemplate" />
                        <DxColumn data-field="customerId"
                                  caption="Ügyfél-azonosító"
                                  :allowEditing="false" />
                        <DxColumn data-field="name"
                                  caption="Díjfizető neve"
                                  :allowEditing="false" />
                        <DxColumn data-field="flat"
                                  caption="Cím"
                                  :allowEditing="false" />

                        <template #idColumnTemplate="{ data: cellInfo }">
                            {{ rowId(cellInfo) }}
                        </template>

                    </DxDataGrid>
                    </div>
            </template>
        </DxPopup>
    </div>
</template>

<script>
    import DxList from "devextreme-vue/list";
    import FotavOutputTableService from "../services/FotavOutputTable.service";
    import FotavInputTableService from "../services/FotavInputTable.service";
    import DxForm, {
        DxItem as DxFormItem,
        DxButtonItem,
        DxLabel,
        DxGroupItem,
        DxSimpleItem
    } from "devextreme-vue/form";
    import DxPopup, {
        DxToolbarItem as DxPopupToolbarItem
    } from "devextreme-vue/popup";
    import DxToolbar, { DxItem as DxToolbarItem } from "devextreme-vue/toolbar";
    import DxSelectBox from "devextreme-vue/select-box";
    import DxDataGrid, {
        DxGrouping,
        DxGroupPanel,
        DxSearchPanel,
        DxPaging,
        DxPager,
        DxSorting,
        DxScrolling,
        DxFilterRow,
        DxColumn,
        DxEditing,
        DxLookup,
        DxRequiredRule,
        DxPopup as DxDataGridEditPopup,
        DxPosition,
        DxForm as DxDatagridEditForm,
        DxButton,
        DxColumnFixing,
        DxRowDragging,
        DxSelection
    } from "devextreme-vue/data-grid";
    import { DxScrollView } from 'devextreme-vue/scroll-view';
    import { DxCheckBox } from 'devextreme-vue/check-box';
    import CustomStore from "devextreme/data/custom_store";
    import { DxButton as DxBtn } from 'devextreme-vue/button';
    import DxDateBox, { DxCalendarOptions } from 'devextreme-vue/date-box';
    import fileDownload from 'js-file-download';
    import moment from 'moment';

    export default {
        name: 'FotavOutputTable',
        components: {
            DxPopup,
            DxFormItem,
            DxButtonItem,
            DxLabel,
            DxForm,
            DxGroupItem,
            DxSimpleItem,
            DxToolbarItem,
            DxPopupToolbarItem,
            DxSelectBox,
            DxList,
            DxGrouping,
            DxGroupPanel,
            DxSearchPanel,
            DxPaging,
            DxPager,
            DxSorting,
            DxScrolling,
            DxFilterRow,
            DxColumn,
            DxEditing,
            DxLookup,
            DxRequiredRule,
            DxPosition,
            DxDatagridEditForm,
            DxButton,
            DxDataGridEditPopup,
            DxColumnFixing,
            DxRowDragging,
            DxDataGrid,
            DxScrollView,
            DxToolbar,
            DxBtn,
            DxDateBox,
            DxCalendarOptions,
            DxCheckBox,
            DxSelection
        },
        data() {
            return {
                datagrid: null,
                datagridGR: null,
                dataSource: new CustomStore({
                    key: "id",
                    load: () => FotavOutputTableService.get(),
                    remove: key => FotavOutputTableService.delete(key)
                }),
                customerSource: new CustomStore({
                    load: () => FotavOutputTableService.getCustomersByDateRange(this.generateReportFormData),
                    remove: key => FotavOutputTableService.delete(key)
                }),
                popup: null,
                popupGR: null,
                templates: [],
                selectedTemplate: null,
                selectedMonth: moment().subtract(1, 'months'),
                closeBtn: {
                    icon: 'close',
                    text: 'Bezár',
                    onClick: () => this.popup.hide()
                },
                generateBtn: {
                    icon: 'video',
                    text: 'Adatok kiszámítása',
                    onClick: () => this.generateStatement()
                },
                closeBtnGR: {
                    icon: 'close',
                    text: 'Bezár',
                    onClick: () => this.popupGR.hide()
                },
                generateBtnGR: {
                    icon: 'video',
                    text: 'Riportok generálása',
                    onClick: () => this.generateRiport()
                },
                calendarFromComponent: null,
                calendarToComponent: null,
                calendarOptionsFrom: {
                    onInitialized: (e) => this.calendarFromComponent = e.component, 
                    value: moment().subtract(1, 'months').startOf('month'),
                    max: moment().subtract(1, 'months').startOf('month'),
                    displayFormat: "monthAndYear",
                    dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
                    calendarOptions: {
                        minZoomLevel: "century",
                        maxZoomLevel: "year"
                    },
                    onValueChanged: (e) => {
                        this.calendarToComponent.option('min', e.component.option('value'));
                        this.datagridGR.refresh();
                    }
                },
                calendarOptionsTo: {
                    onInitialized: (e) => this.calendarToComponent = e.component, 
                    value: moment().subtract(1, 'months').startOf('month'),
                    min: moment().subtract(1, 'months').startOf('month'),
                    max: moment().subtract(1, 'months').startOf('month'),
                    displayFormat: "monthAndYear",
                    dateSerializationFormat: "yyyy-MM-ddTHH:mm:ss",
                    calendarOptions: {
                        minZoomLevel: "century",
                        maxZoomLevel: "year"
                    },
                    onValueChanged: (e) => {
                        this.calendarFromComponent.option('max', e.component.option('value'));
                        this.datagridGR.refresh();
                    }
                },
                selectedRowKeys: [],
                generateReportFormData: {
                    from: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DDTHH:mm:ss'),
                    to: moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DDTHH:mm:ss'),
                    selectedCustomers: []
                },
            };
        },
        methods: {
            onInitialized(e) {
                this.datagrid = e.component;
            },
            onInitializedGR(e) {
                this.datagridGR = e.component;
            },
            onInitNewRow(e) {
                new Promise(resolve => setTimeout(resolve, 10)).then(()=>{
                    e.component.saveEditData();
                    e.component.deselectAll();
                });
            },
            onRowPrepared(e) {
                if (e.component.getVisibleRows()[e.rowIndex] &&
                    e.component.getVisibleRows()[e.rowIndex].isNewRow &&
                    e.rowType == 'data')
                    e.rowElement.classList.add('d-none');
            },
            rowId: function (cellInfo) {
                return cellInfo.row.rowIndex + 1;
            },
            onToolbarPreparing(e) {
                e.toolbarOptions.items.unshift({
                    location: 'after',
                    template: 'generateStatement'
                });

                e.toolbarOptions.items.unshift({
                    location: 'before',
                    template: 'generateReportBtn'
                });
            },
            openPopup() {
                if (this.popup) {
                    this.popup.show();
                }
            },
            onPopupInit(e) {
                this.popup = e.component;
            },
            onShowing(e) {
                FotavInputTableService.get().then(result => {
                    this.templates = result.map(i => { return { id: i.id, name: i.filename } });
                });
            },
            generateStatement() {
                let params = {
                    templateId: this.selectedTemplate,
                    month: moment(this.selectedMonth).format('YYYY-MM-DD')
                }

                FotavOutputTableService.insert(params).then(result => {
                    this.datagrid.refresh();
                    this.popup.hide();
                });
            },
            openPopupGR() {
                if (this.popupGR) {
                    this.popupGR.show();
                }
            },
            onPopupInitGR(e) {
                this.popupGR = e.component;
            },
            generateRiport() {
                this.popupGR.hide();
                this.datagrid.beginCustomLoading('Riportok generálása folyamatban...');

                FotavOutputTableService.generateReport(this.generateReportFormData).then(result => {
                    let filename = 'Riportok_' + moment().format('YYYYMMDD') + '.zip';

                    if (result.type == 'application/error') {
                        filename = 'hibalista.txt';
                    }

                    this.datagrid.endCustomLoading();
                    fileDownload(result, filename);
                });
            },
            onSelectionChanged({ selectedRowKeys, selectedRowsData }) {
                console.log(selectedRowsData);
                this.generateReportFormData.selectedCustomers = selectedRowsData.map(m => (
                    { key: m.customerId, value: m.name }
                    ));
            },
            dateFormat(cellInfo) {
                var options = { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' };
                var formatter = new Intl.DateTimeFormat('hu-HU', options);
                return formatter.format(new Date(cellInfo.value));
            },
            monthFormat(cellInfo) {
                var options = { year: 'numeric', month: 'long' };
                var formatter = new Intl.DateTimeFormat('hu-HU', options);
                return formatter.format(new Date(cellInfo.value));
            },
            downloadBtnClick(e) {
                let params = {
                    id: e.row.data.id
                };

                this.datagrid.beginCustomLoading('Szétosztási eredmények letöltése..');

                FotavOutputTableService.download(params)
                    .then(result => {
                        let filename = e.row.data.filename;

                        if (result.type == 'application/error') {
                            filename = 'hibalista.txt';
                        }

                        this.datagrid.endCustomLoading();
                        fileDownload(result, filename);
                    });
            },
            printBtnClick(e) {
                let params = {
                    id: e.row.data.id
                };

                FotavOutputTableService.download(params)
                    .then(result => {
                        console.log(result);
                    });
            }
        }
    }
</script>

<style lang="scss" scoped>
    #mapScrollview {
        height: 100%;
    }
    ::v-deep .grid {
        fill-opacity: 0;
    }
    ::v-deep .dx-scrollable {
        width: 100%;
    }

    ::v-deep .dx-scrollable-content {
        padding-bottom: 0 !important;
    }

    ::v-deep .dx-datagrid-header-panel .dx-toolbar {
        padding: 3px 10px;
    }

    ::v-deep .dx-datagrid-edit-popup .dx-state-readonly {
        border: none !important;
    }

    .positionid {
        display: block;
        float: left;
        width: 19px;
        text-align: right;
        margin-right: 3px;
    }
    ::v-deep .dx-datagrid, ::v-deep .dx-toolbar {
        background-color: transparent;
    }
    ::v-deep .dx-toolbar-text-auto-hide .dx-button .dx-icon {
        line-height: 20px;
    }
    .warning-icon {
        font-size: 18px;
        color: #ff0000;
        vertical-align: bottom;
    }
    .warning-icon-header {
        font-size: 18px;
        vertical-align: bottom;
    }
    ::v-deep .form-input {
        margin-bottom: 10px;

        label {
            margin: 10px 0;
        }
    }
    ::v-deep .dx-datagrid-rowsview .dx-select-checkboxes-hidden > tbody > tr > td > .dx-select-checkbox {
        display: inline-block !important;
    }
</style>